import { replaceNaN } from "../../utils"

export function parseDimension(value, replacement) {
    return replaceNaN(parseInt(value), replacement)
}